// https://github.com/facebook/react/issues/18123#issuecomment-608136383
const emptyArrayInstance = Object.freeze([]);

export const emptyArray = <T>(): T[] => {
  // Ignoring the `readonly` part
  // @ts-ignore
  return emptyArrayInstance as T[];
};
